import React from 'react';
import { CampaignList } from './Email';

const Marketing = ({ lob }) => <CampaignList lob={lob} channelFilter={null} title="Marketing campaigns" testKey="marketing" />;
export default Marketing;
